import {
    BUILDING_SET_VALID,
    BUILDING_SET_VALUE,
    CITY_SET_VALID,
    CITY_SET_VALUE,
    FIRST_NAME_SET_VALID,
    FIRST_NAME_SET_VALUE,
    EMAIL_SET_VALID,
    EMAIL_SET_VALUE,
    KRA_PIN_NUMBER_SET_VALID,
    KRA_PIN_NUMBER_SET_VALUE,
    MOBILE_NUMBER_SET_VALID,
    MOBILE_NUMBER_SET_VALUE,
    PO_BOX_SET_VALID,
    PO_BOX_SET_VALUE,
    POSTAL_CODE_SET_VALID,
    POSTAL_CODE_SET_VALUE,
    REINITIALIZE,
    STREET_ADDRESS_SET_VALID,
    STREET_ADDRESS_SET_VALUE,
    FORM_VALID_DOCTORS_PI_PERSONAL_DETAILS_FORM,
    FORM_INVALID_DOCTORS_PI_PERSONAL_DETAILS_FORM,
    SURNAME_SET_VALUE,
    SURNAME_SET_VALID,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    ID_PASSPORT_SET_VALUE,
    ID_PASSPORT_SET_VALID,
    PERSONAL_DETAIL_ID_SET_VALID,
    PERSONAL_DETAIL_ID_SET_VALUE,
    REFERRED_SET_VALUE,
    REFERRED_SET_VALID,
    API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
    API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
} from '../../actions/doctorsPi/personalDetails';
import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

export const initPersonalDetails = {
    personalDetailId: 0,
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    form: {
        firstName: { value: null, error: null, status: null },
        surname: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        mobileNumber: { value: null, error: null, status: null },
        idPassport: { value: null, error: null, status: null },
        kraPinNumber: { value: null, error: null, status: null },
        city: { value: null, error: null, status: null },
        streetAddress: { value: null, error: null, status: null },
        building: { value: null, error: null, status: null },
        postalBox: { value: null, error: null, status: null },
        postalCode: { value: null, error: null, status: null },
        referred: { value: null, error: null, status: null },
    },
};

export default (state = initPersonalDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: null };
        case API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };
        case FORM_VALID_DOCTORS_PI_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_DOCTORS_PI_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case PERSONAL_DETAIL_ID_SET_VALUE:
            return { ...state, personalDetailId: action.value };

        case PERSONAL_DETAIL_ID_SET_VALID:
            return { ...state, personalDetailId: 0 };

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));

        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SURNAME_SET_VALUE:
            return updateFormField('surname', (field) => ({
                ...field,
                value: action.value,
            }));

        case SURNAME_SET_VALID:
            return updateFormField('surname', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MOBILE_NUMBER_SET_VALUE:
            return updateFormField('mobileNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case MOBILE_NUMBER_SET_VALID:
            return updateFormField('mobileNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_PASSPORT_SET_VALUE:
            return updateFormField('idPassport', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_PASSPORT_SET_VALID:
            return updateFormField('idPassport', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_PIN_NUMBER_SET_VALUE:
            return updateFormField('kraPinNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case KRA_PIN_NUMBER_SET_VALID:
            return updateFormField('kraPinNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CITY_SET_VALUE:
            return updateFormField('city', (field) => ({
                ...field,
                value: action.value,
            }));
        case CITY_SET_VALID:
            return updateFormField('city', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case STREET_ADDRESS_SET_VALUE:
            return updateFormField('streetAddress', (field) => ({
                ...field,
                value: action.value,
            }));
        case STREET_ADDRESS_SET_VALID:
            return updateFormField('streetAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BUILDING_SET_VALUE:
            return updateFormField('building', (field) => ({
                ...field,
                value: action.value,
            }));
        case BUILDING_SET_VALID:
            return updateFormField('building', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PO_BOX_SET_VALUE:
            return updateFormField('postalBox', (field) => ({
                ...field,
                value: action.value,
            }));
        case PO_BOX_SET_VALID:
            return updateFormField('postalBox', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POSTAL_CODE_SET_VALUE:
            return updateFormField('postalCode', (field) => ({
                ...field,
                value: action.value,
            }));
        case POSTAL_CODE_SET_VALID:
            return updateFormField('postalCode', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case REFERRED_SET_VALUE:
            return updateFormField('referred', (field) => ({
                ...field,
                value: action.value,
            }));
        case REFERRED_SET_VALID:
            return updateFormField('referred', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case REINITIALIZE:
            return initBiasharaFlexiCover;
        default:
            return state;
    }
};
